module.exports = __webpack_public_path__ + "static/img/teamvip.4171ed0.png";


//////////////////
// WEBPACK FOOTER
// ./static/svg/teamvip.png
// module id = YGxM
// module chunks = 16